<template>
	<div class="users mx-7">
		<v-btn small fab class="mb-3" color="primary" @click="showNewUserForm = !showNewUserForm">
			<v-icon>mdi-plus</v-icon>
		</v-btn>
		<UserForm v-if="showNewUserForm"
			:space="space"
			:specialities="specialities"
			@add-user="addUser"
			class="mb-5"/>
		<p v-if="users.length == 0" class="font-weight-thin ml-2" v-translate>No users created.</p>
		<v-list v-else flat>
			<UserItem v-for="user in activeUsers"
				:key="user.id" :user="user"
				@edit-user="editUser"
				@delete-user="deleteUser"
				@deactivate-user="deactivateUser"
				@activate-user="activateUser" />
		</v-list>
		<template v-if="deactivatedUsers.length > 0">
			<v-divider class="my-3"></v-divider>
			<v-list flat>
				<UserItem v-for="user in deactivatedUsers"
					:key="user.id" :user="user"
					@edit-user="editUser"
					@delete-user="deleteUser"
					@deactivate-user="deactivateUser"
					@activate-user="activateUser" />
			</v-list>
		</template>
	</div>
</template>

<script>
import UserForm from "@/components/settings/UserForm.vue";
import UserItem from "@/components/settings/UserItem.vue";

export default {
	name: "Users",
	props: ["users", "specialities", "space"],
	components: {
		UserForm,
		UserItem
	},
	data: () => ({
		showNewUserForm: false
	}),
	computed: {
		activeUsers() {
			return this.users.filter(u => !u.deactivated);
		},
		deactivatedUsers() {
			return this.users.filter(u => u.deactivated);
		}
	},
	methods: {
		addUser(user) {
			this.$emit("add-user", user);
			this.showNewUserForm = false;
		},
		deleteUser(user) {
			this.$emit("delete-user", user);
		},
		editUser(user) {
			this.$router.push({
				name: "edit-user",
				params: { uid: user.id, specialities: this.specialities }
			});
		},
		deactivateUser(user) {
			this.$emit("deactivate-user", user);
		},
		activateUser(user) {
			this.$emit("activate-user", user);
		}
	}
};
</script>